import React, { useEffect, useRef } from "react";
import SingleChoice from "../question-types/SingleChoice";
import MultipleChoice from "../question-types/MultipleChoice";
import { useExam } from "../../context/ExamContext";
import { QuestionTypes } from "../../enums";

const Question = ({ question, type }) => {
  const { activeQuestion, setActiveQuestion } = useExam();
  const questionRef = useRef(null);

  const renderQuestionBody = () => {
    switch (type) {
      case QuestionTypes.MULTIPLE_CHOICE_SINGLE_ANSWER:
        return <SingleChoice question={question} />;

      case QuestionTypes.YES_NO:
        return <SingleChoice question={question} />;

      case QuestionTypes.TRUE_FALSE:
        return <SingleChoice question={question} isTrueFalse={true} />;

      case QuestionTypes.MULTIPLE_CHOICE_MULTIPLE_ANSWER:
        return <MultipleChoice question={question} />;

      default:
        return <div>Unsupported question type: {type}</div>;
    }
  };


  return (
    <div
      ref={questionRef}
      className={`question-item ${activeQuestion === question.questionNumber ? "active" : ""
        }`}
      onClick={() => setActiveQuestion(question.questionNumber)}
    >
      <div className="question-title">
        <strong
          style={{ marginLeft: "-6px" }}
          className={`inline-block mr-[5px]  px-1 ${activeQuestion === question.questionNumber
            ? 'questionBorderActive'
            : 'questionBorder'
            }`}
        >
          {question.questionNumber}
        </strong>
        {question.question || "No question provided"}
      </div>


      <div className="question-options">{renderQuestionBody()}</div>
    </div>
  );
};

export default Question;
